import { createAsyncThunk } from '@reduxjs/toolkit';
import { WalletTransaction } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchWalletTransaction, FindWalletTransaction, GetWalletTransaction } from './interface';

export const findWalletTransaction = createAsyncThunk(
  'walletTransaction/findWalletTransaction',
  async (values: FindWalletTransaction, { rejectWithValue }) => {
    try {
      const response = await WalletTransaction.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createWalletTransaction = createAsyncThunk(
  'walletTransaction/createWalletTransaction',
  async (values: CreatePatchWalletTransaction, { rejectWithValue }) => {
    try {
      const response = await WalletTransaction.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchWalletTransaction = createAsyncThunk(
  'walletTransaction/patchWalletTransaction',
  async ({ id, ...values }: CreatePatchWalletTransaction, { rejectWithValue }) => {
    try {
      const response = await WalletTransaction.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getWalletTransaction = createAsyncThunk(
  'walletTransaction/getWalletTransaction',
  async ({ id }: GetWalletTransaction, { rejectWithValue }) => {
    try {
      const response = await WalletTransaction.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);